import { roleTypes, RouteI, userPlanTypes } from 'safe'
import Clients from './views/Clients/Clients'
import Dealers from './views/Dealers/Dealers'
import Inventory from './views/Inventory/Inventory'
import Existence from './views/operations/Existence'
// import BankAccounts from './views/BankAccountsOld/BankAccounts'

import { AiFillWechat, AiOutlineHistory, AiTwotoneTool } from 'react-icons/ai'
import { BiSpreadsheet, BiTransfer } from 'react-icons/bi'
import {
  BsArchiveFill,
  BsArrowsCollapse,
  BsFillBasket3Fill,
  BsGraphUp,
} from 'react-icons/bs'
import { FaFileInvoice, FaReadme } from 'react-icons/fa'
import { GiReceiveMoney } from 'react-icons/gi'
import {
  HiDocumentReport,
  HiOutlineShoppingCart,
  HiOutlineTruck,
  HiOutlineUserGroup,
  HiUserGroup,
} from 'react-icons/hi'
import { IoIosAddCircle, IoMdCash } from 'react-icons/io'
import { RiExchangeDollarLine, RiHandCoinFill } from 'react-icons/ri'
import { TiPrinter } from 'react-icons/ti'
import { VscTypeHierarchySub } from 'react-icons/vsc'
import Restaurant from './assets/images/Restaurante.svg'
import AccountingPlan from './views/Accounting/AccountingPlan'
import AccountingRecord from './views/Accounting/AccountingRecord'
import Balances from './views/Accounts/Balances'
import Category from './views/Category/Category'
import Configuration from './views/Configuration/Configuration'
import NotMasterConfiguration from './views/Configuration/NotMasterConfiguration'
import Employee from './views/Employee/Employee'
import AccountReceivable from './views/Finances/AccountReceivable'
import BillToPay from './views/Finances/BillToPay'
import Income from './views/Finances/Income'
import Outflow from './views/Finances/Outflow'
import Services from './views/Inventory/Services'
import Historic from './views/operations/Historic'
import Transfers from './views/operations/Transfers'
import Payroll from './views/Payroll/Payroll'
import PendingPurchases from './views/Purchases/PurchasesHistoric'
import Rates from './views/Rates/Rates'
import Reports from './views/Reports/Reports'
import FoodOrder from './views/Restaurants/FoodOrder'
import { FoodTable } from './views/Restaurants/FoodTable'
import HistoricFoodOrder from './views/Restaurants/HistoricFoodOrder'
import { Waiters } from './views/Restaurants/Waiters'
import Budgets from './views/Sells/Budgets'
import HistoricSells from './views/Sells/HistoricSells'
import Sells from './views/Sells/Sells'
import Suscribers from './views/Suscribers/Suscribers'
import SubscriptionAnalytics from './views/Suscriptions/SubscriptionAnalytics'
import Suscriptions from './views/Suscriptions/Suscriptions'
import VirtualAssistantPage from './views/VirtualAssistant/VirtualAssistantPage'

export const getRoutes = (
  userRole: roleTypes,
  userPlan: userPlanTypes
): RouteI[] => {
  const routes: RouteI[] = []
  // routes.push({
  //   title: 'Inicio',
  //   path: 'home',
  //   exact: true,
  //   icon: HiOutlineHome,
  //   subMenu: [
  //     {
  //       title: 'Principal',
  //       path: 'home',
  //       exact: true,
  //       icon: HiOutlineHome,
  //       component: Home,
  //     }
  //   ]
  // });

  routes.push({
    title: 'Tasas',
    path: 'rates',
    exact: true,
    icon: RiExchangeDollarLine,
    tooltipMessage: Rates,
    disabled: userRole === 'waiter',
    // disabled: !(userRole === 'admin' || userRole === 'master' || userRole === 'cashier')
  })

  routes.push({
    title: 'Ventas',
    path: 'modulo_ventas',
    exact: true,
    icon: RiHandCoinFill,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'cashier' ||
      userRole === 'seniat'
    ),
    subMenu: [
      {
        title: 'Nueva Venta',
        path: 'ventas',
        exact: true,
        icon: IoIosAddCircle,
        component: Sells,
        // disabledRole: userRole === 'seniat'
      },
      // {
      //   title: 'Ventas Pendientes',
      //   path: 'historicopendientes',
      //   exact: true,
      //   icon: MdPendingActions,
      //   component: HistoricPending,
      // },
      {
        title: 'Histórico de Ventas',
        path: 'historicoventas',
        exact: true,
        icon: AiOutlineHistory,
        component: HistoricSells,
        disabledRole: userRole === 'cashier',
      },
      {
        title: 'Presupuestos',
        path: 'budgets',
        exact: true,
        icon: AiOutlineHistory,
        component: Budgets,
        disabledRole: userRole === 'cashier' || userRole === 'seniat',
      },
      // {
      //   title: 'Presupuestos',
      //   path: 'presupuestos',
      //   exact: true,
      //   icon: FaMoneyBill,
      //   component: Budget,
      // },
    ],
  })

  routes.push({
    title: 'Compras',
    path: 'modulo_compras',
    exact: true,
    icon: BsFillBasket3Fill,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'seniat'
    ),
    subMenu: [
      // {
      //   title: 'Ingreso con Factura',
      //   path: 'ingreso_con_factura',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: Purchase,
      // },
      // {
      //   title: 'Ingreso',
      //   path: 'unified_path',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: UnifiedLoad,
      // },
      {
        title: 'Compras',
        path: 'compras',
        exact: true,
        icon: HiOutlineShoppingCart,
        component: PendingPurchases,
      },
      // {
      //   title: 'Ingreso con Nota',
      //   path: 'ingreso_con_nota',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: DeliveryNoteLoad,
      // },
      // {
      //   title: 'Notas de Entrega',
      //   path: 'notas_de_entrega',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: DeliveryNotes,
      // },
      // {
      //   title: 'Facturar Notas',
      //   path: 'facturar_notes_de_entrega',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: CloseOpenDeliveryNotes,
      // },
      // {
      //   title: 'Orden de Compra',
      //   path: 'orden_de_compra',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: PurchaseOrder,
      // },
      // {
      //   title: 'Ordenes de Compra',
      //   path: 'ordenes',
      //   exact: true,
      //   icon: HiOutlineShoppingCart,
      //   component: OrdersHistoric,
      // }
    ],
  })

  routes.push({
    title: 'Inventario',
    path: 'inventario',
    exact: true,
    icon: BsArchiveFill,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'seniat'
    ),
    subMenu: [
      {
        title: 'Artículos',
        path: 'inventory',
        exact: true,
        icon: BsArchiveFill,
        component: Inventory,
      },
      {
        title: 'Categorias',
        path: 'categorias',
        exact: true,
        icon: VscTypeHierarchySub,
        component: Category,
      },
      // {
      //   title: 'Almacenes',
      //   path: 'Almacenes',
      //   exact: true,
      //   icon: FaWarehouse,
      //   component: CombinedLocation,
      // },
      // {
      //   title: 'Catálogo de Articulos',
      //   path: 'catatalogo',
      //   exact: true,
      //   icon: GiArchiveResearch,
      //   component: InventoryList,
      // },
      {
        title: 'Almacenes',
        path: 'existencia',
        exact: true,
        icon: BsArrowsCollapse,
        component: Existence,
      },
      // {
      //   title: 'Ajustes de Existencia',
      //   path: 'ajustes',
      //   exact: true,
      //   icon: HiAdjustments,
      //   component: Adjustments,
      // },
      // {
      //   title: 'Requisiciones',
      //   path: 'requisiciones',
      //   exact: true,
      //   icon: AiOutlinePullRequest,
      //   component: Requisitions,
      // },
      {
        title: 'Transferencias',
        path: 'transferencias',
        exact: true,
        icon: BiTransfer,
        component: Transfers,
        disabled: userPlan === 'emprendedor',
      },
      {
        title: 'Histórico de Movimientos',
        path: 'historico',
        exact: true,
        icon: AiOutlineHistory,
        component: Historic,
      },
      {
        title: 'Servicios',
        path: 'servicios',
        exact: true,
        icon: BsArchiveFill,
        component: Services,
      },
      // {
      //   title: 'Ajustes Masivos de Precio',
      //   path: 'price_adjustments',
      //   exact: true,
      //   icon: AiOutlineHistory,
      //   component: PriceAdjustments,
      // },
      // {
      //   title: 'Existencia',
      //   path: 'existencia',
      //   exact: true,
      //   icon: BiArchive,
      //   component: Existence,
      // },

      // {
      //   title: 'Depositos',
      //   path: 'depositos',
      //   exact: true,
      //   icon: FaWarehouse,
      //   component: Warehouse
      // },
      // {
      //   title: 'Transferencias',
      //   path: 'transferencias',
      //   exact: true,
      //   icon: HiOutlineSwitchHorizontal,
      //   component: Transfers,
      // },
      // {
      //   title: 'Unidades',
      //   path: 'unidades',
      //   exact: true,
      //   icon: AiOutlineSubnode,
      //   component: Unit,
      // },
    ],
  })

  routes.push({
    title: 'Terceros',
    path: 'terceros',
    exact: true,
    icon: HiUserGroup,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'seniat'
    ),
    // component: Clients,
    subMenu: [
      {
        title: 'Clientes',
        path: 'clientes',
        exact: true,
        icon: HiOutlineUserGroup,
        component: Clients,
      },
      {
        title: 'Proveedores',
        path: 'proveedores',
        exact: true,
        icon: HiOutlineTruck,
        component: Dealers,
      },
      // {
      //   title: 'Vendedores',
      //   path: 'vendedores',
      //   exact: true,
      //   icon: HiOutlineUserGroup,
      //   component: Sellers,
      //   disabled: userPlan === 'emprendedor'
      // },
    ],
  })

  routes.push({
    title: 'Restaurante',
    path: 'restaurantes',
    exact: true,
    icon: Restaurant,
    disabled: !(
      userRole === 'master' ||
      (['general_manager', 'admin', 'cashier', 'waiter'].includes(userRole) &&
        ['pyme', 'corporativo'].includes(userPlan))
    ),
    subMenu: [
      {
        title: 'Mesoneros',
        path: 'mesoneros',
        exact: true,
        icon: GiReceiveMoney,
        component: Waiters,
        disabledRole: ['waiter', 'cashier'].includes(userRole),
      },
      {
        title: 'Mesas',
        path: 'mesas',
        exact: true,
        icon: GiReceiveMoney,
        component: FoodTable,
        disabledRole: userRole === 'cashier',
      },
      {
        title: 'Comandas Activas',
        path: 'comandas',
        exact: true,
        icon: GiReceiveMoney,
        component: FoodOrder,
      },
      {
        title: 'Historial de Comandas',
        path: 'historico_comandas',
        exact: true,
        disabledRole: ['waiter', 'seniat', 'cashier'].includes(userRole),
        icon: GiReceiveMoney,
        component: HistoricFoodOrder,
      },
    ],
  })

  routes.push({
    title: 'Suscripciones',
    path: 'suscripcion',
    exact: true,
    icon: FaFileInvoice,
    disabled: !(
      userRole === 'master' ||
      (['general_manager', 'admin', 'cashier'].includes(userRole) &&
        ['pyme', 'corporativo'].includes(userPlan))
    ),
    subMenu: [
      {
        title: 'Estadísticas',
        path: 'estadisticas',
        exact: true,
        icon: BsGraphUp,
        component: SubscriptionAnalytics,
        disabledRole: !(
          userRole === 'master' || userRole === 'general_manager'
        ),
      },
      {
        title: 'Suscripciones',
        path: 'suscripciones',
        exact: true,
        icon: FaFileInvoice,
        component: Suscriptions,
      },
      {
        title: 'Suscriptores',
        path: 'suscriptores',
        exact: true,
        icon: FaFileInvoice,
        component: Suscribers,
      },
    ],
  })

  routes.push({
    title: 'Finanzas',
    path: 'finanzas',
    exact: true,
    icon: IoMdCash,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'seniat'
    ),
    subMenu: [
      {
        title: 'Entradas',
        path: 'ingreso',
        exact: true,
        icon: GiReceiveMoney,
        component: Income,
      },
      {
        title: 'Salidas',
        path: 'egreso',
        exact: true,
        icon: GiReceiveMoney,
        component: Outflow,
      },
      {
        title: 'Cuentas por pagar',
        path: 'cuentasporpagar',
        exact: true,
        icon: GiReceiveMoney,
        component: BillToPay,
      },
      {
        title: 'Cuentas por cobrar',
        path: 'cuentasporcobrar',
        exact: true,
        icon: GiReceiveMoney,
        component: AccountReceivable,
      },
    ],
  })

  // routes.push({
  //   title: 'Finanzas',
  //   path: 'finanzas',
  //   exact: true,
  //   icon: HiOutlineCurrencyDollar,
  //   subMenu: [
  //     {
  //       title: 'Balances',
  //       path: 'balances',
  //       exact: true,
  //       icon: GiReceiveMoney,
  //       component: Balances,
  //     },
  //     {
  //       title: 'Cuentas',
  //       path: 'cuentas',
  //       exact: true,
  //       icon: MdAccountBalanceWallet,
  //       component: BankAccounts,
  //     },
  //   ],
  // })

  // routes.push({
  //   title: 'Herramientas',
  //   path: 'herramientas',
  //   exact: true,
  //   icon: AiOutlineTool,
  //   subMenu: [

  //   ],
  // })

  // routes.push({
  //   title: 'Transacciones',
  //   path: 'transacciones',
  //   exact: true,
  //   icon: VscSymbolOperator,
  //   subMenu: [
  //     {
  //       title: 'Operaciones',
  //       path: 'existencia',
  //       exact: true,
  //       icon: BsArrowsCollapse,
  //       component: Existence,
  //     },
  //     {
  //       title: 'Ajustes de Existencia',
  //       path: 'ajustes',
  //       exact: true,
  //       icon: HiAdjustments,
  //       component: Adjustments,
  //     },
  //     {
  //       title: 'Requisiciones',
  //       path: 'requisiciones',
  //       exact: true,
  //       icon: AiOutlinePullRequest,
  //       component: Requisitions,
  //     },
  //     {
  //       title: 'Transferencias',
  //       path: 'transferencias',
  //       exact: true,
  //       icon: BiTransfer,
  //       component: Transfers,
  //     },
  //     {
  //       title: 'Histórico de Movimientos',
  //       path: 'historico',
  //       exact: true,
  //       icon: AiOutlineHistory,
  //       component: Historic,
  //     },
  //   ],
  // })

  // routes.push({
  //   title: 'Despachos',
  //   path: 'despacho',
  //   exact: true,
  //   icon: FaTruck,
  //   subMenu: [
  //     {
  //       title: 'Despachos',
  //       path: 'despachos',
  //       exact: true,
  //       icon: FaTruck,
  //       component: Deliveries,
  //     },
  //   ],
  // })

  // routes.push({
  //   title: 'Ensamblado',
  //   path: 'assembly',
  //   exact: true,
  //   icon: GiJoin,
  //   subMenu: [
  //     {
  //       title: 'Ordenes',
  //       path: 'orden',
  //       exact: true,
  //       icon: IoIosAddCircle,
  //       component: Assembly,
  //     },
  //     // {
  //     //   title: 'Histórico de movimientos',
  //     //   path: 'historicoproduction',
  //     //   exact: true,
  //     //   icon: IoIosAddCircle,
  //     //   component: HistoricAssembly,
  //     // }
  //   ],
  // })

  // routes.push({
  //   title: 'Nota de entrega',
  //   path: 'notadeentrega',
  //   exact: true,
  //   icon: FaFileInvoice,
  //   disabled: true,
  //   subMenu: [
  //     {
  //       title: 'Nueva Nota de Entrega',
  //       path: 'notaventa',
  //       exact: true,
  //       icon: IoIosAddCircle,
  //       component: DeliveryNote,
  //     },
  //     {
  //       title: 'Notas de Entrega Pendientes',
  //       path: 'pendienteentrega',
  //       exact: true,
  //       icon: MdPendingActions,
  //       component: PendingDeliveryNote,
  //     },
  //     {
  //       title: 'Histórico de Notas de Entrega',
  //       path: 'historiconotas',
  //       exact: true,
  //       icon: AiOutlineHistory,
  //       component: HitoricDeliveryNote,
  //     },
  //     {
  //       title: 'Presupuestos',
  //       path: 'presupuestos',
  //       exact: true,
  //       icon: FaMoneyBill,
  //       component: Budget,
  //     },
  //   ],
  // })

  // routes.push({
  //   title: 'Talento humano',
  //   path: 'talentohumano',
  //   exact: true,
  //   icon: IoPerson,
  //   subMenu: [
  //     {
  //       title: 'Nueva Nota de Entrega',
  //       path: 'notaventa',
  //       exact: true,
  //       icon: IoIosAddCircle,
  //       component: DeliveryNote,
  //     },
  //   ],
  // })

  // routes.push({
  //   title: 'Contabilidad',
  //   path: 'contabilidad',
  //   exact: true,
  //   icon: FaPiggyBank,
  //   subMenu: [
  //     {
  //       title: 'Nueva Nota de Entrega',
  //       path: '_contabilidad',
  //       exact: true,
  //       icon: IoIosAddCircle,
  //       component: DeliveryNote,
  //     },
  //   ],
  // })

  routes.push({
    title: 'Contabilidad',
    path: 'contabilidad',
    exact: true,
    icon: FaReadme,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'seniat'
    ),
    subMenu: [
      {
        title: 'Plan de cuentas',
        path: 'plan_de_cuentas',
        exact: true,
        icon: IoIosAddCircle,
        component: AccountingPlan,
      },
      {
        title: 'Registros Contables',
        path: 'registros_contables',
        exact: true,
        icon: IoIosAddCircle,
        component: AccountingRecord,
      },
      // {
      //   title: 'Arqueo de caja',
      //   path: 'arqueo',
      //   exact: true,
      //   icon: IoIosAddCircle,
      //   component: SafeBox,
      // },
      // // {
      // //   title: 'Balances',
      // //   path: 'balances',
      // //   exact: true,
      // //   icon: GiReceiveMoney,
      // //   component: Balances,
      // // },
      // // {
      // //   title: 'Cuentas',
      // //   path: 'cuentas',
      // //   exact: true,
      // //   icon: MdAccountBalanceWallet,
      // //   component: BankAccounts,
      // // },
      // {
      //   title: 'Cuenta por pagar',
      //   path: 'cuentaporpagar',
      //   exact: true,
      //   icon: GiReceiveMoney,
      //   component: BillsToPay,
      // },
      // {
      //   title: 'Cuentas por cobrar',
      //   path: 'cuentasporcobrar',
      //   exact: true,
      //   icon: GiReceiveMoney,
      //   component: AccountReceivable,
      // },
      // // {
      // //   title: 'Orden de Pago',
      // //   path: 'ordendepago',
      // //   exact: true,
      // //   icon: GiReceiveMoney,
      // //   component: PaymentOrders,
      // // },
      // {
      //   title: 'Ingresos',
      //   path: 'ingresos',
      //   exact: true,
      //   icon: GiReceiveMoney,
      //   component: Chargues,
      // },
      // {
      //   title: 'Egresos',
      //   path: 'egresos',
      //   exact: true,
      //   icon: GiReceiveMoney,
      //   component: Payments,
      // },
    ],
  })

  routes.push({
    title: 'Bancos',
    path: 'bancos',
    exact: true,
    icon: IoMdCash,
    disabled: !(userRole === 'admin' || userRole === 'master'),
    subMenu: [
      {
        title: 'Bancos',
        path: 'bancos',
        exact: true,
        icon: GiReceiveMoney,
        component: Balances,
      },
    ],
  })

  routes.push({
    title: 'Nómina',
    path: 'nomina',
    exact: true,
    icon: BiSpreadsheet,
    disabled: !(
      userRole === 'master' ||
      (['admin', 'seniat'].includes(userRole) && userPlan === 'corporativo')
    ),
    subMenu: [
      {
        title: 'Nóminas',
        path: 'nomina',
        exact: true,
        icon: BiSpreadsheet,
        component: Payroll,
      },
      {
        title: 'Empleados',
        path: 'empleado',
        exact: true,
        icon: GiReceiveMoney,
        component: Employee,
      },
    ],
  })

  routes.push({
    title: 'Reportes',
    path: 'reportes',
    exact: true,
    icon: HiDocumentReport,
    disabled: !(
      userRole === 'admin' ||
      userRole === 'master' ||
      userRole === 'seniat'
    ),
    subMenu: [
      {
        title: 'Reportes',
        path: 'reportes',
        exact: true,
        icon: GiReceiveMoney,
        component: Reports,
      },
    ],
  })

  routes.push({
    title: 'Asistente Virtual',
    path: 'asistentevirtual',
    exact: true,
    icon: AiFillWechat,
    disabled: userRole !== 'master',
    subMenu: [
      {
        title: 'Asistente Virtual Financiero',
        path: 'init',
        exact: true,
        icon: GiReceiveMoney,
        component: VirtualAssistantPage,
      },
    ],
  })

  routes.push({
    title: 'Configuración',
    path: 'configuracion',
    exact: true,
    icon: AiTwotoneTool,
    disabled: !(userRole === 'master'),
    subMenu: [
      // {
      //   title: 'Cajas Registradoras',
      //   path: 'cajas_registradoras',
      //   exact: true,
      //   icon: RiComputerLine,
      //   component: SafeBoxes,
      // },
      {
        title: 'Configuración',
        path: 'sub_configuracion',
        exact: true,
        icon: TiPrinter,
        component: Configuration,
      },
    ],
  })

  routes.push({
    title: 'Configuración',
    path: 'configuracion_2',
    exact: true,
    icon: AiTwotoneTool,
    disabled:
      userRole === 'master' || userRole === 'seniat' || userRole === 'waiter',
    subMenu: [
      // {
      //   title: 'Cajas Registradoras',
      //   path: 'cajas_registradoras',
      //   exact: true,
      //   icon: RiComputerLine,
      //   component: SafeBoxes,
      // },
      {
        title: 'Configuración',
        path: 'sub_configuracion_2',
        exact: true,
        icon: TiPrinter,
        component: NotMasterConfiguration,
      },
    ],
  })

  // routes.push({
  //   title: 'Forma Libre',
  //   path: 'forma_libre',
  //   exact: true,
  //   icon: HiOutlineNewspaper,
  //   subMenu: [
  //     {
  //       title: 'Forma Libre',
  //       path: 'forma_libre',
  //       exact: true,
  //       icon: HiOutlineNewspaper,
  //       component: FreeForms,
  //     },
  //   ],
  // })

  return routes
}
